import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export function LoadingScreen() {
  const [visible, setVisible] = useState(() => !sessionStorage.getItem('berleto_loaded'));

  useEffect(() => {
    if (!visible) return;
    sessionStorage.setItem('berleto_loaded', '1');
    const timer = setTimeout(() => setVisible(false), 1800);
    return () => clearTimeout(timer);
  }, [visible]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-0 z-[9999] flex items-center justify-center"
          style={{ background: '#FAF9F6' }}
        >
          <motion.img
            src="/logo/berleto-logo-dark.png"
            alt="Berleto"
            className="w-20 h-20 object-contain"
            animate={{ rotate: 360 }}
            transition={{ duration: 1.2, ease: 'linear', repeat: Infinity }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
